import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-2d8cda41"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component popup" }
const _hoisted_2 = { class: "popup_box contents__box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "popup-title" }, "PACS Server Connection", -1))
const _hoisted_4 = { class: "pacs-setting-box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Title", -1))
const _hoisted_6 = { class: "info-box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "IP", -1))
const _hoisted_8 = { class: "info-box" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Port", -1))
const _hoisted_10 = { class: "info-box" }
const _hoisted_11 = {
  key: 0,
  class: "error_msg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _imports_0,
        class: "close_icon",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closePopup()))
      }),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputData.title) = $event)),
              placeholder: "Input Title",
              onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setConnectState && _ctx.setConnectState(...args)))
            }, null, 544), [
              [_vModelText, _ctx.inputData.title]
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputData.ip) = $event)),
              placeholder: "Input IP",
              onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.setConnectState && _ctx.setConnectState(...args)))
            }, null, 544), [
              [_vModelText, _ctx.inputData.ip]
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputData.port) = $event)),
              placeholder: "Input Port",
              onKeyup: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.setConnectState && _ctx.setConnectState(...args)))
            }, null, 544), [
              [_vModelText, _ctx.inputData.port]
            ])
          ])
        ]),
        (!_ctx.connectState)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_11, "* PACS 서버 연결에 실패했습니다. 정보를 다시 입력해주세요."))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "button__blue confirm_btn",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleConnectClick()))
        }, "Connect")
      ])
    ])
  ]))
}